import * as types from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  employeeReport: [],
};

export default function employeeReportReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_REQUEST:
    case types.FETCH_DAY_WISE_ATTENDANCE_REPORT_REQUEST:
    case types.FETCH_LATE_ATTENDANCE_REPORT_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_SUCCESS:
    case types.FETCH_DAY_WISE_ATTENDANCE_REPORT_SUCCESS:
    case types.FETCH_LATE_ATTENDANCE_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_FAILURE:
    case types.FETCH_DAY_WISE_ATTENDANCE_REPORT_FAILURE:
    case types.FETCH_LATE_ATTENDANCE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_ABSENTEEISM_REPORT_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: null, 
        success: false 
      };

    case types.FETCH_ABSENTEEISM_REPORT_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        employeeReport: action.payload, 
        success: true 
      };

    case types.FETCH_ABSENTEEISM_REPORT_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.payload,
        success: false
      };

    case types.FETCH_EXTRA_HOURS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_EXTRA_HOURS_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_EXTRA_HOURS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.GET_MOBILE_PUNCH_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.GET_MOBILE_PUNCH_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.GET_MOBILE_PUNCH_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_LEAVE_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_LEAVE_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_LEAVE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    // Shift Report
    case types.FETCH_SHIFT_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_SHIFT_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };
    case types.FETCH_SHIFT_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    // Shift Details Report
    case types.FETCH_SHIFT_DETAILS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_SHIFT_DETAILS_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };
    case types.FETCH_SHIFT_DETAILS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    // Shift Log Report
    case types.FETCH_SHIFT_LOG_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_SHIFT_LOG_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };
    case types.FETCH_SHIFT_LOG_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.FETCH_LEAVE_BALANCE_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_LEAVE_BALANCE_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_LEAVE_BALANCE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.FETCH_FORM6_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_FORM6_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_FORM6_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.FETCH_FORM34_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_FORM34_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_FORM34_REPORT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.FETCH_BREAKIN_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_BREAKIN_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeReport: action.payload || [],
      };

    case types.FETCH_BREAKIN_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        employeeReport: [],
        error: action.error,
      };

    case types.RESET_ATTENDANCE_REPORT:
      return { ...initialState };
      
    default:
      return state;
  }
}
